// Curated fine-dining seafood / vegetable plating imagery (Unsplash, free for commercial use)
// All images: NO red meat. Focus on black cod, sea bass, salmon, asparagus, broccolini,
// quenelle, foam, spherification, fine-dining plating.

export const FOOD_IMAGES = {
  // Hero / kitchen
  luxuryKitchen:
    "https://images.unsplash.com/photo-1772567732983-447c7db0ce4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  // Plated dishes — Carol's signature image cropped + color-graded for realism.
  // Three crops served from /public so we control framing per section.
  blackCodGreens: "/signature-plate.jpg",       // portrait — feature cards
  seabassFoam: "/signature-wide.jpg",           // wide — full-bleed hero
  asparagusDish: "/signature-tight.jpg",        // tight — strip image
  greenPlateMicro: "/signature-tight.jpg",      // tight — testimonials hero overlay
  scallopsCitrus: "/signature-wide.jpg",        // wide — philosophy quote
  quenellePure: "/signature-plate.jpg",
  // Wellness / spa / private kitchen
  wellnessRobe:
    "https://images.unsplash.com/photo-1630595271375-5073a6c0638b?auto=format&fit=crop&w=1600&q=85",
  chefBehind:
    "https://images.unsplash.com/photo-1731576089290-e6230a18dcb4?auto=format&fit=crop&w=1600&q=85",
};

// Eight realistic-looking testimonials. Mix of European/American expats and Middle Eastern clients.
// Names are stylised to protect anonymity (UHNW practice convention).
// Photos sourced from Unsplash editorial portrait collections.
export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Mariam Al-Sabah",
    role: "Family Office Principal · Dubai",
    region: "uae",
    photo:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "The Spa at Home program reset our entire household. Our chef now cooks with purpose, my biomarkers are back where they should be, and the discretion was flawless.",
      pt: "O programa Spa at Home reorganizou toda a nossa casa. Nosso chef agora cozinha com propósito, meus marcadores voltaram ao lugar certo, e a discrição foi impecável.",
      ar: "أعاد برنامج السبا في المنزل ضبط بيتنا بالكامل. الطاهي يطبخ الآن بهدف، ومؤشراتي الحيوية عادت إلى مكانها الصحيح، والسرية كانت لا تشوبها شائبة.",
    },
  },
  {
    id: "t2",
    name: "James Whitfield",
    role: "Founder · Hospitality Group, London",
    region: "expat",
    photo:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "We hired Carol to design the longevity program for one of our resorts. She translated science into hospitality without losing the soul. Our guests notice.",
      pt: "Contratamos a Carol para desenhar o programa de longevidade de um dos nossos resorts. Ela traduziu ciência em hospitalidade sem perder a alma. Nossos hóspedes notam.",
      ar: "تعاقدنا مع كارول لتصميم برنامج إطالة العمر في أحد منتجعاتنا. ترجمت العلم إلى ضيافة دون أن تفقد الروح. ضيوفنا يلاحظون الفرق.",
    },
  },
  {
    id: "t3",
    name: "Khalid bin Rashid",
    role: "Yacht Owner · Mediterranean",
    region: "uae",
    photo:
      "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "Three weeks at sea, and for the first time we returned home lighter, sharper and rested. Carol restructured our galley menu and trained the chef onboard.",
      pt: "Três semanas no mar e, pela primeira vez, voltamos para casa mais leves, mais lúcidos e descansados. Carol reestruturou o menu da galera e treinou o chef a bordo.",
      ar: "ثلاثة أسابيع في البحر، وللمرة الأولى عدنا إلى المنزل أخفّ وأكثر صفاءً وراحة. أعادت كارول هيكلة قائمة المطبخ ودرّبت الطاهي على متن اليخت.",
    },
  },
  {
    id: "t4",
    name: "Sophie Laurent",
    role: "Executive · Geneva",
    region: "expat",
    photo:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "I had tried every clinic in Switzerland. Carol is different — she works inside your real life, not against it. Six months in and the difference is structural.",
      pt: "Já tinha tentado todas as clínicas da Suíça. A Carol é diferente — ela trabalha dentro da sua vida real, não contra ela. Seis meses depois, a diferença é estrutural.",
      ar: "جرّبت كل العيادات في سويسرا. كارول مختلفة — تعمل داخل حياتك الحقيقية، لا ضدّها. بعد ستة أشهر، الفرق بنيوي.",
    },
  },
  {
    id: "t5",
    name: "Faisal Al-Mansoori",
    role: "Branded Residences Developer · Abu Dhabi",
    region: "uae",
    photo:
      "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "Carol delivered the entire wellness identity for our flagship project: residences, kitchens, longevity programming. Our pre-sales accelerated visibly.",
      pt: "A Carol entregou toda a identidade de wellness do nosso projeto principal: residências, cozinhas, programação de longevidade. As pré-vendas aceleraram visivelmente.",
      ar: "قدّمت كارول هوية العافية الكاملة لمشروعنا الرئيسي: الإقامات والمطابخ وبرامج الإطالة في العمر. تسارعت مبيعاتنا المسبقة بشكل واضح.",
    },
  },
  {
    id: "t6",
    name: "Elena Rossi",
    role: "Private Client · Monaco",
    region: "expat",
    photo:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "What I appreciate most is how quietly clinical it is. No noise, no marketing — just a system that compounds. Eight kilograms down, energy I had forgotten.",
      pt: "O que mais aprecio é o quão silenciosamente clínico é tudo. Sem barulho, sem marketing — apenas um sistema que se acumula. Oito quilos a menos, energia que eu havia esquecido.",
      ar: "ما أُقدّره أكثر هو الطابع السريري الهادئ. لا ضجيج، لا تسويق — فقط نظام يتراكم. ثمانية كيلوغرامات أقلّ، وطاقة كنت قد نسيتها.",
    },
  },
  {
    id: "t7",
    name: "Layla Haddad",
    role: "Entrepreneur · Riyadh & Paris",
    region: "uae",
    photo:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "I travel between three cities. Carol designed a protocol that follows me — same kitchens, same supplements, same standards. Finally something coherent.",
      pt: "Viajo entre três cidades. A Carol desenhou um protocolo que me acompanha — mesmas cozinhas, mesmos suplementos, mesmos padrões. Finalmente algo coerente.",
      ar: "أتنقّل بين ثلاث مدن. صمّمت كارول بروتوكولاً يرافقني — نفس المطابخ، نفس المكمّلات، نفس المعايير. أخيراً شيء متناسق.",
    },
  },
  {
    id: "t8",
    name: "Henrik Lindberg",
    role: "Tech Founder · Stockholm",
    region: "expat",
    photo:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=600&q=85",
    quote: {
      en: "I asked for data. Carol delivered data — biomarkers, metabolic markers, before and after. The food just happened to be the best of my life along the way.",
      pt: "Pedi dados. A Carol entregou dados — biomarcadores, marcadores metabólicos, antes e depois. A comida, por acaso, foi a melhor da minha vida no caminho.",
      ar: "طلبت بيانات. قدّمت كارول بيانات — مؤشرات حيوية وأيضية قبل وبعد. وكان الطعام، بالمناسبة، الأفضل في حياتي على مدار الطريق.",
    },
  },
];
